import { FontWeight, FontFamily } from './Typography.types';

export const getFontClass = (fontWeight?: FontWeight, fontFamily?: FontFamily): string => {
  if (!fontFamily) {
    const weightToLegacyFont = {
      [FontWeight.REGULAR]: FontFamily.METRIC_R,
      [FontWeight.MEDIUM]: FontFamily.METRIC_R_MEDIUM,
      [FontWeight.SEMIBOLD]: FontFamily.METRIC_R_SEMIBOLD,
    };
    return `font-${weightToLegacyFont[fontWeight || FontWeight.REGULAR]}`;
  }

  // For Inter variable font, use font-weight utilities with the single font family
  if (fontFamily === FontFamily.INTER) {
    const weightClasses = {
      [FontWeight.REGULAR]: 'font-normal',
      [FontWeight.MEDIUM]: 'font-medium',
      [FontWeight.SEMIBOLD]: 'font-semibold',
    };
    return `font-inter ${weightClasses[fontWeight || FontWeight.REGULAR]}`;
  }

  // For other font families, map weight to specific font family variants
  const fontWeightMap = {
    [FontFamily.METRIC_R]: {
      [FontWeight.REGULAR]: FontFamily.METRIC_R,
      [FontWeight.MEDIUM]: FontFamily.METRIC_R_MEDIUM,
      [FontWeight.SEMIBOLD]: FontFamily.METRIC_R_SEMIBOLD,
    },
    [FontFamily.SOURCE_SANS_PRO]: {
      [FontWeight.REGULAR]: FontFamily.SOURCE_SANS_PRO,
      [FontWeight.MEDIUM]: FontFamily.SOURCE_SANS_PRO_SEMIBOLD,
      [FontWeight.SEMIBOLD]: FontFamily.SOURCE_SANS_PRO_SEMIBOLD,
    },
  };

  const familyWeightMap = fontWeightMap[fontFamily as keyof typeof fontWeightMap];
  if (familyWeightMap) {
    const targetFontFamily = familyWeightMap[fontWeight || FontWeight.REGULAR];
    return `font-${targetFontFamily}`;
  }

  // Fallback to the specified font family
  return `font-${fontFamily}`;
};
